import { getMaxUploadSizeMb } from '@lib/shared/utils/get-max-upload-size-mb';

/**
 * Single source of truth for the document upload size
 * limit: flows and the builder, the pdf-inspector, Public
 * API documents, Insights, and doc-vault / comment / task
 * attachments. Override with
 * `NEXT_PUBLIC_MAX_UPLOAD_SIZE_MB` (see
 * `getMaxUploadSizeMb`).
 *
 * Not covered on purpose: avatars, logos, CSV imports,
 * Vercel-proxied images, and LLM-bound PDFs. Their limits
 * come from other constraints.
 */
const MAX_UPLOAD_SIZE_MB = getMaxUploadSizeMb();

export const MAX_UPLOAD_SIZE_BYTES = Math.floor(
  MAX_UPLOAD_SIZE_MB * 1024 * 1024
);

/** e.g. "50 MB" — for hints and error copy. */
export function formatMaxUploadSize(): string {
  return `${MAX_UPLOAD_SIZE_MB} MB`;
}

/** Shared copy for server-side rejections of an oversized upload. */
export function uploadSizeLimitExceededMessage(): string {
  return `File exceeds the ${formatMaxUploadSize()} limit.`;
}
